import type { ColumnDef, VisualizationConfig } from '@deckspace/types';
import { useSurfaceContext } from '../../components/surface/SurfaceContext';
import { ChartRenderer } from '../../components/ChartRenderer';

interface PieChartViewProps {
  nodeId: string;
  mapping: { labels: string; values: string };
  queryConfig?: Record<string, unknown>;
  displayConfig?: VisualizationConfig;
  minimized?: boolean;
  width?: number;
  height?: number;
  rows: Record<string, unknown>[];
  columnDefs: ColumnDef[];
}

const EMPTY_CONFIG: VisualizationConfig = {};

export function PieChartView({
  nodeId,
  mapping,
  displayConfig,
  width,
  height,
  rows,
  columnDefs,
}: PieChartViewProps) {
  const { themeKey } = useSurfaceContext();
  return (
    <ChartRenderer
      rows={rows}
      columnDefs={columnDefs}
      config={displayConfig ?? EMPTY_CONFIG}
      chartType="pie"
      mapping={mapping}
      visualizationId={nodeId}
      themeKey={themeKey}
      width={width}
      height={height}
    />
  );
}
